document.addEventListener('DOMContentLoaded', function (){
   if (document.querySelector('.custom-option__checkbox-and-textarea')) {
      const personalizationRadios = document.querySelectorAll('variant-selects input[type="radio"][name="Personalization"]');
      const customBlock = document.querySelector('.custom-option__checkbox-and-textarea');
      let customTextFieldInfo = customBlock.querySelector('p');
      let customTextField = customBlock.querySelector('textarea');

      if (personalizationRadios) {
         personalizationRadios.forEach(function (item){
            if (item.checked && item.value.toLowerCase() === 'yes') {
               switchPersonalizationField(true);
            }

            item.addEventListener('change', function (){
               if (this.checked && this.value.toLowerCase() === 'yes') {
                  switchPersonalizationField(true);
               } else {
                  switchPersonalizationField(false);
               }
            })
         })
      }

      function switchPersonalizationField(activate){
         if (activate) {
            customBlock.classList.add('active');
            customTextFieldInfo.classList.add('active');
            customTextField.setAttribute('required', true);
         } else {
            customBlock.classList.remove('active');
            customTextFieldInfo.classList.remove('active');
            customTextField.value = '';
            customTextField.removeAttribute('required');
         }
      }
   }
});